"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.items = exports.array = exports.ArrayGuard = void 0;
var guard_1 = require("../guard");
var es6_1 = __importDefault(require("fast-deep-equal/es6"));
var ArrayGuard = /** @class */ (function (_super) {
    __extends(ArrayGuard, _super);
    function ArrayGuard(options) {
        var _this = this;
        var itemsGuard = options.items, uniqueItems = options.uniqueItems, lengthOption = options.length;
        if (itemsGuard instanceof guard_1.Guard === false) {
            throw new Error('"items" must an instance of Guard');
        }
        if (uniqueItems !== undefined && typeof uniqueItems !== 'boolean') {
            throw new Error('"uniqueItems" must be undefined or a boolean');
        }
        if (false ===
            (lengthOption === undefined ||
                (typeof lengthOption === 'number' && lengthOption % 1 === 0 && lengthOption >= 0) ||
                (typeof lengthOption === 'object' &&
                    lengthOption !== null &&
                    (lengthOption.max === undefined ||
                        (typeof lengthOption.max === 'number' && lengthOption.max % 1 === 0 && lengthOption.max >= 0)) &&
                    (lengthOption.min === undefined ||
                        (typeof lengthOption.min === 'number' && lengthOption.min % 1 === 0 && lengthOption.min >= 0))))) {
            throw new Error('"length" must be undefined, a non-negative integer or an object with properties "max" and "min" either as undefined or a non-negative integer');
        }
        var _a = options.length === undefined
            ? {}
            : typeof options.length === 'number'
                ? { length: options.length }
                : options.length, max = _a.max, min = _a.min, length = _a.length;
        _this = _super.call(this, {
            type: 'array',
            coerce: function (path, value, coercer) {
                if (Array.isArray(value)) {
                    return value.map(function (item, index) { return itemsGuard.coerce(__spreadArray(__spreadArray([], __read(path), false), [index], false), item, coercer); });
                }
                return value;
            },
            validate: function (path, value) {
                var isLengthValid, _loop_1, index, _a, _b, invalidations, e_1_1;
                var e_1, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!Array.isArray(value)) return [3 /*break*/, 21];
                            isLengthValid = true;
                            if (!(length !== undefined && value.length !== length)) return [3 /*break*/, 2];
                            isLengthValid = false;
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length',
                                    setting: length,
                                    actual: value.length
                                }];
                        case 1:
                            _d.sent();
                            _d.label = 2;
                        case 2:
                            if (!(max !== undefined && value.length > max)) return [3 /*break*/, 4];
                            isLengthValid = false;
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length.max',
                                    setting: max,
                                    actual: value.length
                                }];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4:
                            if (!(min !== undefined && value.length < min)) return [3 /*break*/, 6];
                            isLengthValid = false;
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length.min',
                                    setting: min,
                                    actual: value.length
                                }];
                        case 5:
                            _d.sent();
                            _d.label = 6;
                        case 6:
                            if (!isLengthValid) return [3 /*break*/, 18];
                            if (!uniqueItems) return [3 /*break*/, 11];
                            _loop_1 = function (index) {
                                var currentItem, firstIndex, _e, _f, invalidations, e_2_1;
                                var e_2, _g;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            currentItem = value[index];
                                            firstIndex = value.findIndex(function (item) { return (0, es6_1.default)(item, currentItem); });
                                            if (!(firstIndex !== index)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, {
                                                    path: __spreadArray(__spreadArray([], __read(path), false), [index], false),
                                                    rule: 'uniqueItems',
                                                    setting: true,
                                                    actual: index
                                                }];
                                        case 1:
                                            _h.sent();
                                            return [3 /*break*/, 9];
                                        case 2:
                                            _h.trys.push([2, 7, 8, 9]);
                                            _e = (e_2 = void 0, __values(value.map(function (item, index) { return itemsGuard.validate(__spreadArray(__spreadArray([], __read(path), false), [index], false), item); }))), _f = _e.next();
                                            _h.label = 3;
                                        case 3:
                                            if (!!_f.done) return [3 /*break*/, 6];
                                            invalidations = _f.value;
                                            return [5 /*yield**/, __values(invalidations)];
                                        case 4:
                                            _h.sent();
                                            _h.label = 5;
                                        case 5:
                                            _f = _e.next();
                                            return [3 /*break*/, 3];
                                        case 6: return [3 /*break*/, 9];
                                        case 7:
                                            e_2_1 = _h.sent();
                                            e_2 = { error: e_2_1 };
                                            return [3 /*break*/, 9];
                                        case 8:
                                            try {
                                                if (_f && !_f.done && (_g = _e.return)) _g.call(_e);
                                            }
                                            finally { if (e_2) throw e_2.error; }
                                            return [7 /*endfinally*/];
                                        case 9: return [2 /*return*/];
                                    }
                                });
                            };
                            index = 0;
                            _d.label = 7;
                        case 7:
                            if (!(index < value.length)) return [3 /*break*/, 10];
                            return [5 /*yield**/, _loop_1(index)];
                        case 8:
                            _d.sent();
                            _d.label = 9;
                        case 9:
                            index++;
                            return [3 /*break*/, 7];
                        case 10: return [3 /*break*/, 18];
                        case 11:
                            _d.trys.push([11, 16, 17, 18]);
                            _a = __values(value.map(function (item, index) { return itemsGuard.validate(__spreadArray(__spreadArray([], __read(path), false), [index], false), item); })), _b = _a.next();
                            _d.label = 12;
                        case 12:
                            if (!!_b.done) return [3 /*break*/, 15];
                            invalidations = _b.value;
                            return [5 /*yield**/, __values(invalidations)];
                        case 13:
                            _d.sent();
                            _d.label = 14;
                        case 14:
                            _b = _a.next();
                            return [3 /*break*/, 12];
                        case 15: return [3 /*break*/, 18];
                        case 16:
                            e_1_1 = _d.sent();
                            e_1 = { error: e_1_1 };
                            return [3 /*break*/, 18];
                        case 17:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7 /*endfinally*/];
                        case 18:
                            if (!(Array.isArray(options.includes) && options.includes.length !== 0)) return [3 /*break*/, 20];
                            if (!(options.includes.every(function (includeItem) { return value.some(function (item) { return (0, es6_1.default)(includeItem, item); }); }) === false)) return [3 /*break*/, 20];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'includes',
                                    setting: options.includes,
                                    actual: undefined
                                }];
                        case 19:
                            _d.sent();
                            _d.label = 20;
                        case 20: return [3 /*break*/, 23];
                        case 21: return [4 /*yield*/, {
                                path: path,
                                rule: 'type',
                                setting: 'array',
                                actual: value
                            }];
                        case 22:
                            _d.sent();
                            _d.label = 23;
                        case 23: return [2 /*return*/];
                    }
                });
            },
            convert: function (path, value, converter) {
                return value.map(function (item, index) { return converter(itemsGuard, __spreadArray(__spreadArray([], __read(path), false), [index], false), item); });
            },
            scan: function (path, value, scanner) {
                var index, item;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            index = 0;
                            _a.label = 1;
                        case 1:
                            if (!(index < value.length)) return [3 /*break*/, 4];
                            item = value[index];
                            return [5 /*yield**/, __values(itemsGuard.scan(__spreadArray(__spreadArray([], __read(path), false), [index], false), item, scanner))];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            index++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            },
            substitute: function (path, replacer) {
                return array(__assign(__assign({}, options), { items: replacer(itemsGuard, path) }));
            }
        }) || this;
        _this.options = options;
        return _this;
    }
    return ArrayGuard;
}(guard_1.Guard));
exports.ArrayGuard = ArrayGuard;
/**
 * Contructs a type-guard for an `array` type
 * @param options.items - type-guard for items
 * @param options.length - enforce specific length
 * @param options.uniqueItems - enforce that items are unique (using `fast-deep-equal`)
 */
function array(options) {
    return new ArrayGuard(options);
}
exports.array = array;
/**
 * Contructs a type-guard for an `array` type
 * @param items - type-guard for items
 */
function items(items) {
    return array({ items: items });
}
exports.items = items;
